// Translated services data
export const getServicesData = (language = 'fr') => {
  const services = {
    fr: [
      {
        id: 1,
        title: "Béton Imprimé",
        slug: "beton-imprime",
        description: "Le béton imprimé, également connu sous le nom de béton estampé ou béton empreinte, représente la solution idéale pour transformer vos espaces extérieurs en véritables œuvres d'art.",
        features: [
          "Large choix de motifs et couleurs",
          "Résistant aux intempéries",
          "Entretien minimal",
          "Durabilité exceptionnelle"
        ],
        applications: ["Terrasses", "Allées", "Cours", "Plages de piscine"],
        icon: "Stamp"
      },
      {
        id: 2,
        title: "Béton Désactivé",
        slug: "beton-desactive",
        description: "Le béton désactivé, aussi appelé béton lavé ou béton apparent, est une technique de revêtement extérieur qui révèle la beauté naturelle des granulats contenus dans le béton.",
        features: [
          "Aspect naturel et élégant",
          "Antidérapant",
          "Perméable à l'eau",
          "Écologique"
        ],
        applications: ["Entrées de garage", "Parkings", "Voies piétonnes", "Espaces publics"],
        icon: "Layers"
      },
      {
        id: 3,
        title: "Béton Bâlé",
        slug: "beton-bale",
        description: "Le béton bâlé représente une technique ancestrale remise au goût du jour, offrant une finition unique qui marie parfaitement rusticité et modernité.",
        features: [
          "Texture distinctive",
          "Effet antidérapant",
          "Résistant",
          "Esthétique originale"
        ],
        applications: ["Extérieurs", "Zones de passage", "Cours", "Chemins"],
        icon: "Grip"
      },
      {
        id: 4,
        title: "Béton Lissé",
        slug: "beton-lisse",
        description: "Le béton lissé incarne l'élégance minimaliste et la modernité architecturale. Cette technique de finition produit une surface parfaitement plane, lisse et uniforme.",
        features: [
          "Surface parfaitement plane",
          "Finition moderne et épurée",
          "Entretien très facile",
          "Idéal intérieur et extérieur"
        ],
        applications: ["Plages de piscine", "Terrasses modernes", "Showrooms", "Espaces commerciaux"],
        icon: "Minimize"
      },
      {
        id: 5,
        title: "Béton Ciré",
        slug: "beton-cire",
        description: "Le béton ciré représente l'excellence et le summum du raffinement dans l'univers des revêtements décoratifs.",
        features: [
          "Finition haut de gamme",
          "Sans joints, aspect continu",
          "Résistant à l'eau et aux taches",
          "Large palette de couleurs"
        ],
        applications: ["Intérieurs", "Terrasses couvertes", "Commerces", "Espaces premium"],
        icon: "Sparkles"
      }
    ],
    en: [
      {
        id: 1,
        title: "Stamped Concrete",
        slug: "stamped-concrete",
        description: "Stamped concrete, also known as patterned or imprinted concrete, represents the ideal solution to transform your outdoor spaces into true works of art.",
        features: [
          "Wide choice of patterns and colors",
          "Weather resistant",
          "Minimal maintenance",
          "Exceptional durability"
        ],
        applications: ["Terraces", "Driveways", "Courtyards", "Pool surrounds"],
        icon: "Stamp"
      },
      {
        id: 2,
        title: "Exposed Aggregate Concrete",
        slug: "exposed-aggregate",
        description: "Exposed aggregate concrete, also called washed concrete, is an exterior coating technique that reveals the natural beauty of the aggregates contained in the concrete.",
        features: [
          "Natural and elegant appearance",
          "Non-slip",
          "Water permeable",
          "Ecological"
        ],
        applications: ["Garage entrances", "Parking lots", "Pedestrian paths", "Public spaces"],
        icon: "Layers"
      },
      {
        id: 3,
        title: "Brushed Concrete",
        slug: "brushed-concrete",
        description: "Brushed concrete represents an ancestral technique brought up to date, offering a unique finish that perfectly combines rusticity and modernity.",
        features: [
          "Distinctive texture",
          "Non-slip effect",
          "Resistant",
          "Original aesthetics"
        ],
        applications: ["Outdoors", "Passageways", "Courtyards", "Paths"],
        icon: "Grip"
      },
      {
        id: 4,
        title: "Polished Concrete",
        slug: "polished-concrete",
        description: "Polished concrete embodies minimalist elegance and architectural modernity. This finishing technique produces a perfectly flat, smooth and uniform surface.",
        features: [
          "Perfectly flat surface",
          "Modern and refined finish",
          "Very easy maintenance",
          "Ideal for indoor and outdoor"
        ],
        applications: ["Pool decks", "Modern terraces", "Showrooms", "Commercial spaces"],
        icon: "Minimize"
      },
      {
        id: 5,
        title: "Waxed Concrete",
        slug: "waxed-concrete",
        description: "Waxed concrete represents excellence and the pinnacle of refinement in the world of decorative coatings.",
        features: [
          "High-end finish",
          "Seamless, continuous appearance",
          "Water and stain resistant",
          "Wide color palette"
        ],
        applications: ["Interiors", "Covered terraces", "Shops", "Premium spaces"],
        icon: "Sparkles"
      }
    ]
  };

  return services[language] || services.fr;
};
